import { render, staticRenderFns } from "./VSelectDefault.vue?vue&type=template&id=ab5f8b56&scoped=true&"
import script from "./VSelectDefault.vue?vue&type=script&lang=js&"
export * from "./VSelectDefault.vue?vue&type=script&lang=js&"
import style0 from "./VSelectDefault.vue?vue&type=style&index=0&id=ab5f8b56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5f8b56",
  null
  
)

export default component.exports